import { render, staticRenderFns } from "./FiltersField.vue?vue&type=template&id=56a4bea8&scoped=true"
import script from "./FiltersField.ts?vue&type=script&lang=ts&external"
export * from "./FiltersField.ts?vue&type=script&lang=ts&external"
import style0 from "./FiltersField.scss?vue&type=style&index=0&id=56a4bea8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4bea8",
  null
  
)

export default component.exports